import { create } from "zustand"
import { devtools } from "zustand/middleware"

// 리포트 화면에서의 임시(transient) 정렬 상태.
// 템플릿(sortSetting)과 분리되어 화면 정렬이 영속 템플릿을 오염시키지 않으며,
// 리포트 스코프 내에서만 보존된다(뒤로가기 후 복귀 시 유지 / 새로고침 시 소멸 → 템플릿 seed로 복원).
export interface ReportSortSetting {
  key: string
  order: "asc" | "desc"
}

interface ReportSortState {
  sorts: Record<string, ReportSortSetting | undefined>
  // reportType 별 마지막으로 본 템플릿 id. 재mount(뒤로가기 복귀)와 실제 템플릿 변경을 구분하기 위해 store 에 보존.
  lastTemplateId: Record<string, string | number | undefined>
  setSort: (sortKey: string, sort: ReportSortSetting | undefined) => void
  // 템플릿이 실제로 바뀐 경우에만 해당 reportType 의 화면 정렬을 폐기. 같은 템플릿 재진입 시엔 보존.
  syncTemplate: (reportType: string, templateId: string | number | undefined) => void
}

export const buildReportSortKey = (
  reportType: string,
  sectionIndex: number,
  chartIndex = 0,
): string => `${reportType}:${sectionIndex}:${chartIndex}`

export const createReportSortStore = create<ReportSortState>()(
  devtools(
    (set) => ({
      sorts: {},
      lastTemplateId: {},
      setSort: (sortKey, sort) => set((state) => ({ sorts: { ...state.sorts, [sortKey]: sort } })),
      syncTemplate: (reportType, templateId) =>
        set((state) => {
          if (state.lastTemplateId[reportType] === templateId) {
            return state
          }

          return {
            sorts: Object.fromEntries(
              Object.entries(state.sorts).filter(([key]) => !key.startsWith(`${reportType}:`)),
            ),
            lastTemplateId: { ...state.lastTemplateId, [reportType]: templateId },
          }
        }),
    }),
    {
      store: "reportSort",
      enabled: process.env.NODE_ENV !== "production",
    },
  ),
)
